export default "__VITE_ASSET__ce6257c6__"